"use client";

import { useState } from "react";
import { BenefitsComponent } from "@capex/components/retailplans/benefits.component";
import { ChoosePaymentComponent } from "@capex/components/retailplans/choosepayment.component";
import { PaymentSuccesfulComponent } from "@capex/components/retailplans/paymentsuccessful.component";
import { OTPverificationComponent } from "@capex/components/retailplans/otpverification.component";
import { Form2 } from "@capex/components/retailplans/form2.component";
import { Form1 } from "@capex/components/retailplans/form1.component";
import {
  ProductData,
  PaymentPlan,
  PolicyTerm,
  SignupData,
  QuoteData,
  UserData,
} from "@capex/types";

export const RetailPlans = ({
  productData,
  paymentPlans,
  policyTerms,
  userData,
  currentStage,
  quoteData,
}: {
  productData: ProductData;
  paymentPlans: PaymentPlan[];
  policyTerms: PolicyTerm[];
  userData?: UserData;
  currentStage: number;
  quoteData?: QuoteData;
}) => {
  const isLoggedIn = userData?.email ? true : false;
  const [stage, setStage] = useState<number>(
    currentStage === 3 && isLoggedIn ? 3 : isLoggedIn ? 2 : 1
  );
  const [otp, setOtp] = useState<string>("");
  const [form1Data, setForm1Data] = useState<SignupData>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    bvn: "",
    nin: "",
    dateOfBirth: "",
    TandC: false,
  });
  const [quote, setQuote] = useState<QuoteData>(
    quoteData?.paymentStatus === "Pending"
      ? quoteData
      : {
          Id: 0,
          phoneNumber: "",
          email: "",
          quoteNo: "",
          productCode: "",
          product: "",
          productOption: "",
          premium: 0,
          policyTerm: "",
          paymentTerm: "",
          sumAssured: 0,
          maturityBenefit: 0,
          dateOfBirth: "",
          createDate: "",
          agentPhoneNo: "",
          paymentStatus: "",
          status: "",
          lifeCoverPremium: 0,
        }
  );

  return (
    <div className="h-full grid grid-cols-1 place-content-center">
      {stage === 1 && <Form1 setStage={setStage} setForm1Data={setForm1Data} />}
      {stage === 2 && (
        <Form2
          isLoggedIn={isLoggedIn}
          setStage={setStage}
          form1Data={form1Data}
          productData={productData}
          paymentPlans={paymentPlans}
          policyTerms={policyTerms}
          setQuote={setQuote}
          userData={userData}
        />
      )}
      {stage === 3 && (
        <BenefitsComponent
          setStage={setStage}
          productData={productData}
          quote={quote}
          paymentPlans={paymentPlans}
          currentStage={currentStage}
        />
      )}
      {stage === 4 && (
        <ChoosePaymentComponent
          isLoggedIn={isLoggedIn}
          setStage={setStage}
          quote={quote}
          firstName={userData?.firstName ?? form1Data.firstName}
          lastName={userData?.lastName ?? form1Data.lastName}
        />
      )}
      {stage === 5 && (
        <PaymentSuccesfulComponent
          setStage={setStage}
          phoneNumber={userData?.mobileNumber ?? form1Data.phoneNo}
          email={userData?.email ?? form1Data.email}
          setOtp={setOtp}
          firstName={userData?.firstName ?? form1Data.firstName}
        />
      )}
      {stage === 6 && (
        <OTPverificationComponent
          lastName={userData?.lastName ?? form1Data.lastName}
          email={userData?.email ?? form1Data.email}
          firstName={userData?.firstName ?? form1Data.firstName}
          phoneNumber={userData?.mobileNumber ?? form1Data.phoneNo}
        />
      )}
    </div>
  );
};
